import { Button, Group, Text } from '@mantine/core';
import { alert } from './alert';

const UNDO_TOAST_AUTO_CLOSE_MS = 8000;

/** A one-line success toast with an Undo, when there is something to undo. */
export function showUndoToast(message: string, onUndo?: () => void): void {
  const toastId = alert.success({
    options: { autoClose: UNDO_TOAST_AUTO_CLOSE_MS },
    message: (
      <Group justify="space-between" wrap="nowrap" gap="xs">
        <Text size="sm" lineClamp={1}>
          {message}
        </Text>
        {onUndo && (
          <Button
            size="compact-xs"
            variant="subtle"
            onClick={() => {
              alert.hide(toastId);
              onUndo();
            }}
          >
            Undo
          </Button>
        )}
      </Group>
    ),
  });
}
